import React from "react";
export function TopbarMini(props) {
  let view = props.view;
  let onMenuClick =
    (props.currentStudent, props.adminLogged, props.onMenuClick);
  const title =
    {
      feed: "Feed de Estudos",
      rankings: "Rankings",
      loja: "Loja de Recompensas",
      desafios: "Desafios",
      meritos: "Méritos",
      conteudos: "Reforço",
      tarefas: "Tarefas",
      vestibulares: "Vestibulares",
      simuladores: "Simuladores",
      "simuladores-conteudo": "Simuladores",
      "olimpiada-conteudo": "Olimpíadas",
      transferir: "Enviar Tokens",
      perfil: "Perfil",
      admin: "Administração",
      extrato: "Extrato",
      agendar: "Agendamentos",
      cardapio: "Cardápio",
    }[view] || "Daniel Marlon";
  return (
    <header className={"tb-mini"}>
      <button
        className={"tb-menu-btn"}
        onClick={onMenuClick}
        aria-label={"Menu"}
      >
        <svg
          width={"22"}
          height={"22"}
          viewBox={"0 0 24 24"}
          fill={"none"}
          stroke={"currentColor"}
          strokeWidth={"2.5"}
          strokeLinecap={"round"}
        >
          <line x1={"3"} y1={"6"} x2={"21"} y2={"6"} />
          <line x1={"3"} y1={"12"} x2={"21"} y2={"12"} />
          <line x1={"3"} y1={"18"} x2={"21"} y2={"18"} />
        </svg>
      </button>
      <div
        className={"logo-m"}
        style={{
          flex: 1,
        }}
      >
        {title}
      </div>
    </header>
  );
}
